import axios from 'axios'
export default {
  getOfficeLog: (page = 1) => axios.get('/office_logs', { params: { page: page } }),
  getUsersLog: (page = 1) => axios.get('/user_logs', { params: { page: page } }),
  getCardsLog: (page = 1) => axios.get('/card_logs', { params: { page: page } }),
  getWebHookLogs: (page = 1) => axios.get('/webhook_logs', { params: { page: page } })
}
